import {ftime, fdate} from '../utils/date';

export function formatTime(time) {

  if (!time) {
    return 'invalid time';
  }
  const date = fdate(time);
  const endTime = ftime(time);
  const startTime = ftime(time - 3600 * 1000);

  return `${startTime} - ${endTime} ${date}`;
}

export function formatOnlyTime(time) {

  if (!time) {
    return 'invalid time';
  }
  const endTime = ftime(time);
  const startTime = ftime(time - 3600 * 1000);

  return `${startTime} - ${endTime}`;
}

export function formatDeliveryTime(endExpeckted, deliveryTime) {

    if (!endExpeckted || !deliveryTime) {
      return 'invalid time';
    }
    const endTime = ftime(deliveryTime);
    const startTime = ftime(endExpeckted);

    return `${startTime} - ${endTime}`;
  }



// WEBPACK FOOTER //
// ./src/businessLogic/deliveryTimeFormatter.js